/* unplugin-vue-components disabled */import { render } from "./RealNameGuide.vue?vue&type=template&id=15f5b4aa&scoped=true"
import script from "./RealNameGuide.vue?vue&type=script&lang=js"
export * from "./RealNameGuide.vue?vue&type=script&lang=js"

import "./RealNameGuide.vue?vue&type=style&index=0&id=15f5b4aa&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f5b4aa"]])

export default __exports__